import React, { FC } from "react";
import Card13 from "./Card13";
import { IPost } from "../../@core/interfaces/IPost";

export interface SectionMagazine5Props {
  posts: IPost[];
}

const SectionMagazine5: FC<SectionMagazine5Props> = ({ posts }) => {
  return (
    <div className="nc-SectionMagazine5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {posts
            .map((item, index) => (
              <Card13 key={index} post={item} />
            ))}
      </div>
    </div>
  );
};

export default SectionMagazine5;
